import { MyGame } from './game';
import { MyScene } from './scene';
import { Types } from 'phaser';
const config: Types.Core.GameConfig = {
  type: Phaser.WEBGL,
  width: 512,
  height: 512,
  backgroundColor: '#fefefe',
  parent: 'canvas-container',
  render: {
    pixelArt: true,
    maxLights: 20,
  },
  physics: {
    default: 'arcade',
    arcade: {
      // debug: true,
      gravity: { y: 0 },
    },
  },
  scene: new MyScene(),
};
new MyGame(config);
